import API_ROUTES from '../../../api/apiUri';
import { apiCall } from '../../../api/apiCall';
import logger from '../../../utils/logger';


const normalizeAnnouncementItem = (announcement) => ({
  Id:
    announcement?.Id ??
    announcement?.id ??
    announcement?.AnnouncementId ??
    announcement?.announcementId ??
    null,
  Title: announcement?.Title ?? announcement?.title ?? announcement?.Subject ?? announcement?.subject ?? '',
  title: announcement?.title ?? announcement?.Title ?? announcement?.Subject ?? announcement?.subject ?? '',
  Message: announcement?.Message ?? announcement?.message ?? '',
  message: announcement?.message ?? announcement?.Message ?? '',
  Priority: announcement?.Priority ?? announcement?.priority ?? 'Info',
  priority: announcement?.priority ?? announcement?.Priority ?? 'Info',
  Category: announcement?.Category ?? announcement?.category ?? 'General',
  category: announcement?.category ?? announcement?.Category ?? 'General',
  CreatedAt:
    announcement?.CreatedAt ??
    announcement?.createdAt ??
    announcement?.CreatedOn ??
    announcement?.createdOn ??
    null,
  createdAt:
    announcement?.createdAt ??
    announcement?.CreatedAt ??
    announcement?.CreatedOn ??
    announcement?.createdOn ??
    null,
  ExpiryDate: announcement?.ExpiryDate ?? announcement?.expiryDate ?? null,
  expiryDate: announcement?.expiryDate ?? announcement?.ExpiryDate ?? null,
  IsActive:
    announcement?.IsActive !== undefined
      ? Boolean(announcement.IsActive)
      : announcement?.isActive !== undefined
        ? Boolean(announcement.isActive)
        : true,
  LinkUrl:
    announcement?.LinkUrl ??
    announcement?.linkUrl ??
    announcement?.link_url ??
    null,
  linkUrl:
    announcement?.linkUrl ??
    announcement?.LinkUrl ??
    announcement?.link_url ??
    null,
  LinkText:
    announcement?.LinkText ??
    announcement?.linkText ??
    announcement?.link_text ??
    null,
  linkText:
    announcement?.linkText ??
    announcement?.LinkText ??
    announcement?.link_text ??
    null,
});

const getTimestamp = (value) => {
  if (!value) {
    return 0;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

export const isAnnouncementExpired = (announcement, now = new Date()) => {
  const expiryDate = announcement?.ExpiryDate ?? announcement?.expiryDate ?? null;
  if (!expiryDate) {
    return false;
  }

  const expiryTimestamp = new Date(expiryDate).getTime();
  const currentTimestamp = now instanceof Date ? now.getTime() : new Date(now).getTime();

  if (Number.isNaN(expiryTimestamp) || Number.isNaN(currentTimestamp)) {
    return false;
  }

  return expiryTimestamp <= currentTimestamp;
};

export const getAnnouncementLink = (announcement) => {
  const rawLink =
    announcement?.LinkUrl ?? announcement?.linkUrl ?? announcement?.link_url ?? null;

  if (!rawLink) {
    return null;
  }

  const normalizedLink = String(rawLink).trim();
  if (!/^https?:\/\//i.test(normalizedLink)) {
    return null;
  }

  const linkText =
    announcement?.LinkText ?? announcement?.linkText ?? 'View Link';

  return {
    url: normalizedLink,
    text: String(linkText).trim() || 'View Link',
  };
};

export async function fetchNotifications(employeeId, status) {
  const url = `${API_ROUTES.notification.get_notifications}&employeeId=${employeeId}&status=${status}`;
  const data = await apiCall({ url });
  return data.notifications || [];
}

export async function markNotificationsRead(notificationIds) {
  await apiCall({
    url: API_ROUTES.notification.mark_read,
    method: 'POST',
    data: { NotificationIds: notificationIds },
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function registerDeviceToken(token, employeeId) {
  await apiCall({
    url: API_ROUTES.notification.register_device,
    method: 'POST',
    data: {
      DeviceToken: token,
      EmployeeId: Number(employeeId),
      Tag: `admin_${employeeId}`,
    },
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function show_announcement() {
  try {
    const tenantId = sessionStorage.getItem("activeTenantId");
    // Ensure we pass the activeTenantId to the backend to get the right announcements
    const url = `${API_ROUTES.announcement.show_announcement}&tenantId=${tenantId}`;
    const data = await apiCall({ url });

    // Normalize response (handle both direct array and nested object with announcements array)
    let announcements = [];
    if (Array.isArray(data)) {
      announcements = data;
    } else {
      announcements = data?.announcements || [];
    }

    return announcements
      .map(normalizeAnnouncementItem)
      .sort((a, b) => getTimestamp(b.CreatedAt) - getTimestamp(a.CreatedAt));
  } catch (error) {
    logger.error("Failed to fetch announcements:", error);
    return [];
  }
}
